import MyCoverages from './MyCoverages';

export default MyCoverages